module.exports = function() {
  return new Worker(__webpack_public_path__ + "1bb8c1e7c0df3f50.worker.js");
};